import React, { useMemo } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { buildLeafletLayer, buildLeafletLayerFromCswGeom } from 'src/scenes/Project/scenes/Analytics/smaAnalyticsHelper';
import { MapWrapper } from 'src/components';
import { getColorScheme } from 'src/utils/colorBrewer';
import { getCombinedBounds } from 'src/components/map/mapHelper';
import { thousandsDotAndDecimalComma as tdadc } from 'src/utils/util';
import { upperCaseOnlyFirstLetter as upofl } from 'src/utils/formatters';


const heightVH = n => document.documentElement.clientHeight * (n / 100);

const mapOptions = {
  center: [ -32.48431324745671, -71.25296320202341 ],
  zoomControl: true,
  dragging: true,
  zoom: 16,
  doubleClickZoom: false,
  attributionControl: false,
};

const useStyles = makeStyles(theme => ({
  map: {
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
}));

const interestAreaMapHeight = 50;

const NationalReserves = ({ nationalReserves, interestArea = [] }) => {

  const nationalReservesCount = nationalReserves.results.length;
  const hasNationalReserves = nationalReservesCount > 0;

  const interestAreaLayers = useMemo(() =>
    interestArea.map(ia => buildLeafletLayer({
      features: ia.geojson,
      id: ia.id,
      name: ia.name,
    }))
  , [ interestArea ]);

  const colors = useMemo(() => getColorScheme(nationalReservesCount), [ nationalReservesCount ]);

  const nationalReservesForMap = useMemo(
    () => hasNationalReserves ? nationalReserves.results : [ nationalReserves.closest ],
    [ nationalReserves, hasNationalReserves ],
  );

  const nationalReservesLayers = useMemo(() =>
    nationalReservesForMap.map((pl, index) =>
      buildLeafletLayerFromCswGeom({
        features: [ pl.cswFeatGeom ],
        id: pl.code,
        name: pl.name,
        style: {
          weight: 2,
          fillOpacity: 0.8,
          color: colors[index],
          fillColor: colors[index],
        },
      }),
    )
  , [ nationalReservesForMap, colors ]);

  const classes = useStyles();

  const zoomTo = getCombinedBounds([ ...interestAreaLayers, ...(hasNationalReserves ? nationalReservesLayers : []) ]);

  return (
    <Box mt={1}>
      <MapWrapper
        id="national-reserves-map"
        className={classes.map}
        options={mapOptions}
        height={heightVH(interestAreaMapHeight)}
        layers={[ ...nationalReservesLayers, ...interestAreaLayers ]}
        {...(hasNationalReserves ? { box: nationalReserves.box } : {})}
        bounds={zoomTo}
        fitBoundsOnUpdate
      />
      <Box mt={1} mb={hasNationalReserves ? 3 : 1}>
        <Typography variant="caption" color="textPrimary">
          {nationalReservesCount > 0 ?
            <>El área de interés interseca con {nationalReservesCount} reservas nacionales</>
            :
            <>
              El área de interés NO interseca con ninguna reserva nacional dentro de {tdadc(nationalReserves.bufferInKm.toFixed(2))} km,
              la reserva nacional más cercana es {upofl(nationalReserves.closest.name)} y se encuentra
              a {tdadc(nationalReserves.closest.distanceInKm.toFixed(2))} km
            </>
          }
        </Typography>
      </Box>
      {/* <Cards values={pliscoff.results} columns={columns} variant="condensed" componente /> */}
    </Box>
  );
};

NationalReserves.propTypes = {
  nationalReserves: PropTypes.object,
  interestArea: PropTypes.array,
};


export {
  NationalReserves,
};